var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"div_home"},[_c('div',{staticClass:"main_rules"},[(_vm.data.image)?_c('div',{staticClass:"img_rules"},[_c('img',{attrs:{"src":_vm.data.image}})]):_vm._e(),_c('div',{staticClass:"box_rules"},[_c('div',{staticClass:"ui violet segment text_rules",domProps:{"innerHTML":_vm._s(_vm.parseHtml(_vm.data.text))}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }